export default {"src":"/_next/static/media/OrbTealSmall.eeb9cb8b.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};